import { useState, useEffect } from 'react';
import { Utils } from 'ecrion-components';

export default function useRecaptcha(props) {
  const [recaptcha, setRecaptcha] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    function loadRecaptcha(response) {
      if (response) setRecaptcha(response);
    }

    function errorRecaptcha(response) {
      setError(response);
    }

    Utils.request({
      url: '/backend/recaptcha',
    })
      .then(loadRecaptcha)
      .catch(errorRecaptcha);
  }, []);

  return { recaptcha, error };
}
